var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _path6, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#4E8497"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4332 111V41.1818H99.8423V51.7841H67.081V70.7386H97.4901V81.3409H67.081V100.398H100.115V111H54.4332ZM123.314 41.1818L138.689 66.75H139.234L154.678 41.1818H169.098L147.587 76.0909L169.439 111H154.78L139.234 85.6023H138.689L123.143 111H108.553L130.609 76.0909L108.825 41.1818H123.314ZM179.027 111V41.1818H224.436V51.7841H191.675V70.7386H222.084V81.3409H191.675V100.398H224.709V111H179.027Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112 238H362V397C362 405.837 354.837 413 346 413H128C119.163 413 112 405.837 112 397V238Z",
    fill: "#FAFAFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113 239H361V397C361 405.284 354.284 412 346 412H128C119.716 412 113 405.284 113 397V239Z",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114 240C114 231.716 120.716 225 129 225H347C355.284 225 362 231.716 362 240V240H114V240Z",
    fill: "#DDEAF8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 124.457,
    y: 258.223,
    width: 102.159,
    height: 137.043,
    fill: "url(#paint0_linear_106_389)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 322.965,
    y: 258.223,
    width: 26.5781,
    height: 89.701,
    fill: "url(#paint1_linear_106_389)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 389.453,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 366.195,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 377.824,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 354.566,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 293.105,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 304.734,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 316.363,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 327.988,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 281.477,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 258.223,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 239.078,
    y: 269.852,
    width: 71.4286,
    height: 5.81395,
    fill: "#DEE2E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_389",
    x: 42.4336,
    y: 41.1836,
    width: 186.273,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_389",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_389",
    x1: 126.909,
    y1: 257.807,
    x2: 192.356,
    y2: 394.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4573A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67B46F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_389",
    x1: 323.603,
    y1: 257.951,
    x2: 377.639,
    y2: 302.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4573A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67B46F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExe);
export default __webpack_public_path__ + "static/media/exe.6282a26d305c674b98748017a62efba7.svg";
export { ForwardRef as ReactComponent };